import { FormattedMessage } from "react-intl";
import PlanVariantAddon from "./PlanVariantAddon";
import { addonBounds, filterVisibleAddons } from "../../services/planVariants";
import {
  planVariantAddonShape,
  intlShape,
  planCartShape,
  userShape,
} from "../../shapes";

type PlanVariantAddonsGroupProps = {
  planVariant: $TSFixMe;
  planCart?: planCartShape;
  user: userShape;
  types: string[];
  titleId: string;
  groupId: string;
  onAddonChange?: (value: number, addon: planVariantAddonShape) => void;
  addonQuantity?: (addon: planVariantAddonShape) => number | null | undefined;
  minAmount?: number;
  maxAmount?: number;
  disabled?: boolean;
  intl: intlShape;
};

function PlanVariantAddonsGroup({
  planVariant,
  planCart,
  user,
  types,
  titleId,
  groupId,
  onAddonChange,
  addonQuantity,
  disabled,
  intl,
  minAmount,
  maxAmount,
}: PlanVariantAddonsGroupProps) {
  if (!planVariant?.addons) return null;

  const typedAddons: planVariantAddonShape[] = planVariant.addons.filter(
    (addon: planVariantAddonShape) => addon.type && types.includes(addon.type),
  );
  const addons = filterVisibleAddons<planVariantAddonShape>(
    typedAddons,
    user,
  ).map((addon) => {
    const planCartAddon =
      planCart &&
      planCart.plan_variant &&
      planCart.plan_variant.id === planVariant.id &&
      planCart.addons &&
      planCart.addons.find(
        (a: $TSFixMe) => a.plan_variant_addon?.id === addon.id,
      );

    const explicitMin =
      minAmount ?? (addonQuantity ? addonQuantity(addon) : null);
    const bounds = addonBounds(addon, planVariant, explicitMin);
    const amount = planCartAddon ? planCartAddon.amount : bounds.min;

    return (
      <PlanVariantAddon
        key={addon.id}
        planVariantAddon={addon}
        onChange={onAddonChange}
        amount={amount}
        minAmount={bounds.min}
        maxAmount={maxAmount ?? bounds.max}
        disabled={disabled}
        // @ts-expect-error TS(TS2322) Type is not assignable to type... Remove this comment to see the full error message
        intl={intl}
      />
    );
  });

  if (!addons.length) return null;

  return (
    <>
      <h4 id={`planvariant-${groupId}`}>
        <FormattedMessage id={titleId} />
      </h4>
      <div id={`planvariant-${groupId}-addons`}>{addons}</div>
    </>
  );
}

export default PlanVariantAddonsGroup;
